import React, { useEffect } from "react";

export default function EMagazines() {
    useEffect(() => {
        document.title = "E-Magazines - CGES.CLUB";
    }, []);

    return (
        <>
            <style>
                {`
                    .emag-hero-page {
                        padding: 28px 12px 48px;
                    }

                    .emag-hero-wrap {
                        max-width: 1180px;
                        margin: 0 auto;
                    }

                    .emag-hero-card {
                        position: relative;
                        overflow: hidden;
                        min-height: 72vh;
                        display: flex;
                        align-items: center;
                        padding: clamp(32px, 6vw, 72px);
                        border-radius: 28px;
                        background:
                            radial-gradient(circle at top right, rgba(244, 97, 25, 0.22), transparent 24%),
                            radial-gradient(circle at left center, rgba(255, 255, 255, 0.05), transparent 30%),
                            linear-gradient(135deg, #111827 0%, #0f172a 55%, #151515 100%);
                        border: 1px solid rgba(255, 255, 255, 0.08);
                        box-shadow: 0 24px 60px rgba(0, 0, 0, 0.28);
                    }

                    .emag-hero-card::before {
                        content: "";
                        position: absolute;
                        inset: 0;
                        background:
                            linear-gradient(rgba(255, 255, 255, 0.04) 1px, transparent 1px),
                            linear-gradient(90deg, rgba(255, 255, 255, 0.04) 1px, transparent 1px);
                        background-size: 38px 38px;
                        opacity: 0.12;
                        pointer-events: none;
                    }

                    .emag-hero-card::after {
                        content: "";
                        position: absolute;
                        width: 260px;
                        height: 260px;
                        right: -70px;
                        top: -70px;
                        border-radius: 50%;
                        background: rgba(244, 97, 25, 0.16);
                        filter: blur(10px);
                        pointer-events: none;
                    }

                    .emag-hero-content {
                        position: relative;
                        z-index: 1;
                        max-width: 760px;
                    }

                    .emag-chip {
                        display: inline-flex;
                        align-items: center;
                        gap: 10px;
                        margin-bottom: 18px;
                        padding: 10px 16px;
                        border-radius: 999px;
                        background: rgba(244, 97, 25, 0.12);
                        border: 1px solid rgba(244, 97, 25, 0.24);
                        color: #f7a56f;
                        font-size: 12px;
                        font-weight: 700;
                        letter-spacing: 0.14em;
                        text-transform: uppercase;
                    }

                    .emag-title {
                        margin: 0;
                        color: #ffffff;
                        font-size: clamp(3rem, 8vw, 6.4rem);
                        line-height: 0.92;
                        text-transform: uppercase;
                        letter-spacing: 0.04em;
                    }

                    .emag-title span {
                        display: block;
                        color: var(--main-color-one, #f46119);
                    }

                    .emag-subtitle {
                        margin: 22px 0 0;
                        max-width: 640px;
                        color: rgba(255, 255, 255, 0.8);
                        font-size: clamp(1rem, 2vw, 1.15rem);
                        line-height: 1.9;
                    }

                    .emag-note {
                        margin-top: 28px;
                        color: rgba(255, 255, 255, 0.62);
                        font-size: 0.95rem;
                        text-transform: uppercase;
                        letter-spacing: 0.12em;
                    }

                    @media (max-width: 767px) {
                        .emag-hero-page {
                            padding: 18px 6px 32px;
                        }

                        .emag-hero-card {
                            min-height: 62vh;
                            border-radius: 22px;
                            padding: 28px 20px;
                        }

                        .emag-subtitle {
                            line-height: 1.75;
                        }
                    }
                `}
            </style>

            <section className="emag-hero-page">
                <div className="emag-hero-wrap">
                    <div className="emag-hero-card">
                        <div className="emag-hero-content">
                            <div className="emag-chip">
                                <i className="fa-solid fa-book-open"></i>
                                Coming Soon
                            </div>

                            <h1 className="emag-title">
                                E-Magazines
                                <span>For Gamers</span>
                            </h1>

                            <p className="emag-subtitle">
                                A digital gaming magazine experience is on the way with premium issues,
                                gaming stories, indie spotlights, tutorials, reviews, and more.
                            </p>

                            <div className="emag-note">Monthly issues. Secure reading. Launching soon.</div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
